import { featureCollection, point } from "@turf/turf"

/**
 * 
 * @param {{fast_charger:boolean}[]} pinsArray
 */
export const returnPinType = pinsArray => {
    return pinsArray.map(pin => ({ pin_type: pin.power_kw > 150 ? 'fast_charger' : 'charger', ...pin }))
}

/**
 * 
 * @param {{longitude:number,latitude:number,zoom:number}} viewState 
 * @returns {{center:[longitude:number,latitude:number], zoom:number}|null} an object to use with map.flyTo() function
 */
export const returnSavedView = viewState => {
    if (!viewState || typeof viewState.latitude !== 'number' || typeof viewState.longitude !== 'number') return null
    return {
		center: [viewState.longitude, viewState.latitude],
		zoom: viewState.zoom,
	}
}

export const returnSource = pinsArray => {
    try {
        if (!Array.isArray(pinsArray)) throw new Error('not an array')
        const points = pinsArray.map(pin =>
            point([pin.location.lon, pin.location.lat], { ...pin })
        )
        const s = featureCollection(points)
        return s
    } catch (error) {
        return null
    }
}